import Popup from "./popup";
import BasicTextField from "./basicTextField";
import DialogHeader from "./dialogHeader";
import WebsiteFormDialog from "./websiteFormDialog";
import ErrorDialog from "./errorDialog";
import TimedProgressBar from "./timedProgressBar";
import LoadingDialog from "./loadingDialog";
import Notification from "./notification";
import { authController } from "@reedexpo/authorization-component-ui";
import SuccessDialog from "./successDialog";
import StickyIcon from "./stickyIcon";
import AiLogoButton from "./aiLogoButton";

if (window.authSettings && window.authSettings.usePkce) {
  authController.initialize(window.authSettings);
}

export {
  AiLogoButton,
  BasicTextField,
  DialogHeader,
  ErrorDialog,
  LoadingDialog,
  Notification,
  Popup,
  StickyIcon,
  SuccessDialog,
  TimedProgressBar,
  WebsiteFormDialog,
};
